import { AppColors } from '@cmbg-traky-web/design-system/src/theme';
import { CSSProperties } from 'react';

/**
 * Estilos para los pills de planes de entrega.
 */
export const deliveryPlanPillStyle: CSSProperties = {
  margin: 0,
  fontSize: '12px',
  fontWeight: 400,
  padding: '4px 8px',
  borderRadius: '4px',
  lineHeight: '20px',
  backgroundColor: AppColors.VA.NEUTRALS._30_,
  color: AppColors.VA.NEUTRALS._90_,
  border: 'none'
};
